import React, { useState, useEffect } from "react";
import styles from "./News.module.scss";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import getRequest from "../../../../helpers/getRequest";
import { useTranslation } from "react-i18next";

const News = ({ currentLang, role }) => {
  const [news, setNews] = useState(null);
  const { t } = useTranslation();

  // Request for news
  useEffect(() => {
    try {
      getRequest("v1/articles", null, currentLang.lang).then(
        async (response) => {
          const data = await response.data;
          const sortedNewsArray = data.articles.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
          });
          setNews(sortedNewsArray);
        }
      );
    } catch (err) {
      console.log(err);
    }

    console.log(currentLang);
  }, [currentLang]);

  return (
    <section className={styles.news}>
      <SectionTitle text={t("Recent news")} />
      <a
        href={role !== "CLIENT" ? "/admin/news" : "/news"}
        className={styles.news__grid}
      >
        {news &&
          news.length !== 0 &&
          news.map((n) => (
            <div className={styles.card} key={n.id}>
              <div
                className={styles.card__main}
                style={{ backgroundImage: `url(${n.image})` }}
              ></div>
              <div className={styles.card__overlay}>
                <h5 dangerouslySetInnerHTML={{ __html: n.title }} />
                <p dangerouslySetInnerHTML={{ __html: n.title + "..." }} />
                <span>
                  {currentLang?.lang == "EN"
                    ? new Date(n.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : new Date(n.created_at).toLocaleDateString("de-DE", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                </span>
              </div>
            </div>
          ))}
      </a>
      <div className={styles.pseduo__track}></div>
    </section>
  );
};

export default News;
